import { RpmNoticeUnifyContentPackageType } from '../types/RpmNoticeContentModel';

export const RpmNoticeContentMock: RpmNoticeUnifyContentPackageType = {
  rpm_notice: [
    {
      metadata: {},
      title: '[M]title',
      content_code: '[M]content_code',
      page_title: '[M]page_title',
      card: {
        metadata: {},
        body: '[M]card.body',
        reason: '[M]card.reason',
        evidence: '[M]card.evidence',
      },
      notice_learn_more: [
        {
          header_and_body: {
            metadata: {},
            header: '[M]notice_learn_more.header_and_body.header',
            body_text_md: '[M]notice_learn_more.header_and_body.body_text_md',
          },
        },
      ],
      uid: '[M]uid',
      _content_type_uid: 'rpm_notice',
    },
  ],
};
